import React from 'react';
import Topbar from '../components/Topbar';

const StackLAMP = () => {
  return (
    <div className="flex-1 overflow-y-auto bg-[#0d0f14]">
      <Topbar
        title="Stack LAMP"
        breadcrumb="Visionweb / Sistema / Stack LAMP"
      />

      <div className="p-6 space-y-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Stack Components */}
          <div className="bg-[#13161e] border border-[#2a2e3d] rounded-md p-6">
            <h3 className="text-white font-['Fraunces'] text-xl font-bold mb-4">Stack Actual</h3>
            <div className="space-y-3">
              {[
                { name: 'React', version: '19.0.0', category: 'Frontend', color: '#4f9eff' },
                { name: 'FastAPI', version: '0.110.1', category: 'Backend', color: '#00d68f' },
                { name: 'MongoDB', version: '7.0', category: 'Database', color: '#ffc84a' },
                { name: 'Python', version: '3.11', category: 'Runtime', color: '#b06eff' },
                { name: 'Node.js', version: '18.x', category: 'Runtime', color: '#4f9eff' }
              ].map((item, idx) => (
                <div key={idx} className="flex items-center justify-between p-3 bg-[#0d0f14] border border-[#2a2e3d] rounded-sm">
                  <div className="flex items-center gap-3">
                    <div className="w-2 h-2 rounded-full" style={{ backgroundColor: item.color }} />
                    <div>
                      <div className="text-white font-['Mulish'] text-sm font-semibold">{item.name}</div>
                      <div className="text-[#8b949e] font-['IBM_Plex_Mono'] text-xs">{item.category}</div>
                    </div>
                  </div>
                  <div className="text-[#8b949e] font-['IBM_Plex_Mono'] text-xs">{item.version}</div>
                </div>
              ))}
            </div>
          </div>

          {/* File Structure */}
          <div className="bg-[#13161e] border border-[#2a2e3d] rounded-md p-6">
            <h3 className="text-white font-['Fraunces'] text-xl font-bold mb-4">Estructura del Proyecto</h3>
            <pre className="text-[#8b949e] font-['IBM_Plex_Mono'] text-xs overflow-x-auto">
{`/app
├── backend/
│   ├── server.py
│   ├── requirements.txt
│   └── .env
├── frontend/
│   ├── src/
│   │   ├── components/
│   │   ├── pages/
│   │   ├── contexts/
│   │   ├── utils/
│   │   ├── App.js
│   │   └── index.js
│   ├── package.json
│   └── .env
└── README.md`}
            </pre>
          </div>

          {/* API Routes */}
          <div className="bg-[#13161e] border border-[#2a2e3d] rounded-md p-6 lg:col-span-2">
            <h3 className="text-white font-['Fraunces'] text-xl font-bold mb-4">Rutas API (MVC Flow)</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {[
                { method: 'POST', path: '/api/auth/login', desc: 'Autenticación de usuarios' },
                { method: 'GET', path: '/api/auth/me', desc: 'Obtener usuario actual' },
                { method: 'GET', path: '/api/clientes', desc: 'Listar todos los clientes' },
                { method: 'POST', path: '/api/clientes', desc: 'Crear nuevo cliente' },
                { method: 'PUT', path: '/api/clientes/:id', desc: 'Actualizar cliente' },
                { method: 'DELETE', path: '/api/clientes/:id', desc: 'Eliminar cliente' },
                { method: 'GET', path: '/api/productos', desc: 'Listar productos/servicios' },
                { method: 'POST', path: '/api/productos', desc: 'Crear producto/servicio' },
                { method: 'GET', path: '/api/dominios', desc: 'Listar dominios' },
                { method: 'POST', path: '/api/dominios', desc: 'Registrar dominio' },
                { method: 'GET', path: '/api/dashboard/stats', desc: 'Estadísticas del dashboard' },
                { method: 'GET', path: '/api/export/:module', desc: 'Exportar datos a CSV' }
              ].map((route, idx) => (
                <div key={idx} className="flex items-start gap-3 p-3 bg-[#0d0f14] border border-[#2a2e3d] rounded-sm">
                  <span className={`px-2 py-1 rounded-sm font-['IBM_Plex_Mono'] text-xs font-bold ${
                    route.method === 'GET' ? 'bg-[#4f9eff]/10 text-[#4f9eff] border border-[#4f9eff]' :
                    route.method === 'POST' ? 'bg-[#00d68f]/10 text-[#00d68f] border border-[#00d68f]' :
                    route.method === 'PUT' ? 'bg-[#ffc84a]/10 text-[#ffc84a] border border-[#ffc84a]' :
                    'bg-[#ff5252]/10 text-[#ff5252] border border-[#ff5252]'
                  }`}>
                    {route.method}
                  </span>
                  <div className="flex-1">
                    <div className="text-white font-['IBM_Plex_Mono'] text-xs font-bold mb-1">{route.path}</div>
                    <div className="text-[#8b949e] font-['Mulish'] text-xs">{route.desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Libraries */}
          <div className="bg-[#13161e] border border-[#2a2e3d] rounded-md p-6 lg:col-span-2">
            <h3 className="text-white font-['Fraunces'] text-xl font-bold mb-4">Librerías Principales</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {[
                { category: 'Autenticación', libs: ['JWT', 'bcrypt', 'python-jose'] },
                { category: 'UI Components', libs: ['Radix UI', 'Phosphor Icons', 'Recharts'] },
                { category: 'Utilidades', libs: ['Axios', 'React Router', 'Sonner (Toast)'] },
                { category: 'Estilos', libs: ['Tailwind CSS', 'Google Fonts'] },
                { category: 'Backend', libs: ['Motor (MongoDB)', 'Pydantic', 'CORS'] },
                { category: 'Exportación', libs: ['CSV', 'StreamingResponse'] }
              ].map((group, idx) => (
                <div key={idx} className="bg-[#0d0f14] border border-[#2a2e3d] rounded-sm p-4">
                  <div className="text-[#4f9eff] font-['IBM_Plex_Mono'] text-xs uppercase mb-2">{group.category}</div>
                  <ul className="space-y-1">
                    {group.libs.map((lib, i) => (
                      <li key={i} className="text-[#8b949e] font-['Mulish'] text-xs">• {lib}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StackLAMP;